<template>
  <div class="w-full flex flex-col items-center py-2 px-2 xl:px-0">
    <div class="w-full max-w-7xl flex flex-col gap-2">
      <slot name="header">
        <div class="flex flex-row items-center gap-2">
          <slot name="leading-header" />
          <h3 v-if="title" class="text-2xl">{{ title }}</h3>
        </div>
      </slot>
      <div>
        <slot />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  defineOptions({
    name: "SectionContainer",
  })

  defineProps({
    title: {
      type: String,
      default: null,
    },
  })
</script>
